import React, { useEffect, useState } from 'react';
import { Menu, X, Shield } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-84">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
        <div className="flex justify-between items-center" data-id="element-86">
          <div className="flex items-center space-x-2" data-id="element-87">
            <div className="bg-slate-900 p-1.5 rounded-lg" data-id="element-88">
              <Shield className="h-6 w-6 text-white" data-id="element-89" />
            </div>
            <span className="text-xl font-bold text-slate-900 tracking-tight" data-id="element-90">
              Dataprixa
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-91">
            <a href="#analysis" className="text-slate-600 hover:text-slate-900 font-medium transition-colors" data-id="element-92">
              Analysis
            </a>
            <a href="#topics" className="text-slate-600 hover:text-slate-900 font-medium transition-colors" data-id="element-93">
              Topics
            </a>
            <a href="#about" className="text-slate-600 hover:text-slate-900 font-medium transition-colors" data-id="element-94">
              About
            </a>
            <a href="https://dataprixa.com" className="px-4 py-2 bg-slate-900 text-white rounded-md font-medium hover:bg-slate-800 transition-colors" data-id="element-95">
              Read Articles
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-slate-600" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-96">
            {isMobileMenuOpen ? <X data-id="element-97" /> : <Menu data-id="element-98" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-b border-slate-100 shadow-lg p-4 flex flex-col space-y-4" data-id="element-99">
          <a href="#analysis" className="text-slate-600 font-medium p-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-100">
            Analysis
          </a>
          <a href="#topics" className="text-slate-600 font-medium p-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-101">
            Topics
          </a>
          <a href="#about" className="text-slate-600 font-medium p-2" onClick={() => setIsMobileMenuOpen(false)} data-id="element-102">
            About
          </a>
          <a href="https://dataprixa.com" className="text-blue-600 font-medium p-2" data-id="element-103">
            Visit Dataprixa.com
          </a>
        </div>}
    </header>;
}